<template>
  <v-menu
    :id="id"
    ref="menu2"
    :close-on-content-click="false"
    v-model="menu"
    :nudge-right="40"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <v-text-field
      slot="activator"
      :label="label"
      v-model="dateFormatted"
      append-icon="event"
      readonly
      :placeholder="placeholder"
      :rules="rules"
      :error-messages="errorMessages"
    ></v-text-field>
    <v-date-picker
      v-model="date"
      @input="actualizarCampo(date)"
      locale="es-es"
      color="green lighten-1"
      header-color="primary"
      :allowed-dates="pickerOptions"
    ></v-date-picker>
  </v-menu>
</template>
<script>
import { customFormatter } from '@/utils/dateUtil';
import moment from 'moment';
export default {
  name: 'DatePicker',
  props: {
    id: {
      type: String,
      required: true
    },
    value: {
      type: Date
    },
    label: {
      type: String
    },
    format: {
      type: String,
      default: 'DD-MM-YYYY'
    },
    placeholder: {
      type: String,
      default: 'dd-mm-aaaa'
    },
    required: {
      type: Boolean,
      default: false
    },
    pickerOptions: {
      type: Function,
      default: () => ''
    },
    checkFecha: {
      type: Function,
      default: () => ''
    },
    rules: {
      type: Array,
      default() {
        return [];
      }
    },
    errorMessages: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      menu: false,
      date: null,
      dateFormatted: null
    };
  },
  created() {
    // Formateamos la fecha
    this.dateFormatted = customFormatter(this.value, this.format);
    this.date = customFormatter(this.value, 'YYYY-MM-DD');
  },
  methods: {
    actualizarCampo(valor) {
      this.dateFormatted = customFormatter(valor, this.format);
      this.checkFecha(valor);
      this.$emit('input', moment(valor).toDate());
      this.menu = false;
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss">
.fecha {
  background-color: transparent !important;
}
</style>
